import { ModelBase } from '@/models/model';

class OrganizationalGroup extends ModelBase {
  static namespace = 'group';

  static keyname = 'organizational_group';
}

export default OrganizationalGroup.register();
